import React from 'react'
import Navbar from '../../components/navbar'

import Wave from '../../static/images/addons/wave.svg'

const Industry = () => {
  return (
    <div className='section-nav industry'>
      <Navbar />

      <div className='section-why'>
        <div className='container'>
          <div className='heading'>But, Why Water?</div>
          <div className='row wrapper'>
            <div className='col-md-4 data'>
              <div className='head'>82%</div>
              <p>
                of Indian rural population does not have access to Piped
                Drinking Water !
              </p>
            </div>
            <div className='col-md-4 data'>
              <div className='head'>17th</div>
              <p>
                is India's rank in the list of Extremely High Water-Stressed
                countries !
              </p>
            </div>
            <div className='col-md-4 data'>
              <div className='head'>45%</div>
              <p>
                of water is lost unaccounted in urban areas of India, and no one
                knows about it !
              </p>
            </div>
          </div>
          <div className='conclusion'>
            {/* <div>
              Someone had to do something!
              <br />
              So, we built a <span>profitable business</span> out of it
              following a <span>tripple bottom line</span> approach, to lend a
              hand !
            </div> */}
          </div>
        </div>
        <img src={Wave} className='wave' />
      </div>

      <div className='section-industry'>
        <div className='background-industry'>
          <i class='bi bi-currency-dollar'></i>
        </div>
        <div className='heading-inverse'>The Indian Water Industry</div>
        <div className='container'>
          <div className='row wrapper'>
            <div className='col-md-4 data'>
              <div className='head'>$130 Bln.</div>
              <p>
                will be invested in water and waste water projects by 2030 in
                India !
              </p>
            </div>
            <div className='col-md-4 data'>
              <div className='head'>$7 Bln.</div>
              <p>
                allocated for water supply budget in FY21-22 ! key policy
                initiatives include <span>Jaljeevan Mission</span> and{' '}
                <span>Namami Gange</span> .
              </p>
            </div>
            <div className='col-md-4 data'>
              <div className='head'>20%</div>
              <p>
                growth is the expected in water demand over the next decade !
              </p>
            </div>
          </div>
          <div className='conclusion'>
            <div>
              There is a <span>Problem</span>, there is an{' '}
              <span>Opportunity</span>. We have the{' '}
              <span>Passion, Capabilities and solution</span>.
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Industry
